import { defaultNS, namespaces, resources } from '@ambernord/i18n';
import { LOCALES } from '@ambernord/shared';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: [...LOCALES],
    defaultNS,
    ns: [...namespaces],
    fallbackNS: 'common',
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'ambernord_lang',
      caches: ['localStorage'],
    },
  });

export default i18n;
